<template>
    <div class="lb">
        <div class="lb-left">
            <div class="left-item" v-for="(item, i) in 2" :key="i">
                <img :src="i == 0 ? icon1 : icon2" alt="" class="item-icon">
                <div class="item-text">
                    <div class="left-text1">{{ defaultdata[i].value1 }}</div>
                    <div class="left-text2">
                        <div class="left-val" :ref="`defaultdata[${i}].value2`">{{ rateNum(`defaultdata[${i}].value2`, defaultdata[i].value2) }}</div>
                        <em>%</em>
                    </div>
                </div>
            </div>
        </div>
        <div class="center-line"></div>
        <div class="pie-chart">
            <div class="unit" v-if="defaultdata[0].value3">{{ defaultdata[0].value3 }}</div>
            <img src="@/assets/temimg9/right-bg2.png" alt="" class="bt1">
            <img src="@/assets/temimg9/right-icon1.png" alt="" class="bt2">
            <div :class="`pie-item pie-item-${i}`" v-for="(item, i) in chartlist" :key="i">
                <div class="pie-line">
                    <div class="line-internal" :style="{ width: (+item.value2 / +totalNum * 100) + '%' }"></div>
                </div>
                <div class="line-text1">{{ item.value1 }}</div>
                <div class="line-text2">{{ numformat2(item.value2) }}</div>
            </div>
            <div class="pie-content" ref="piechart"></div>
        </div>
    </div>
</template>

<script>
import * as methods from "./method.js";
import icon1 from '@/assets/temimg9/left-icon1.png'
import icon2 from '@/assets/temimg9/left-icon2.png'

export default {
    name: "template.scope86",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            icon1,
            icon2,
            title: "scope81-新数值条形图-完成",
            timer: null,
            defaultdata: [
                {
                    value1: "月度收款完成率",
                    value2: "89",
                    value3: '单位：千元'
                }, {
                    value1: "对比同期数增长率",
                    value2: "55",
                }, {
                    value1: "预测应收",
                    value2: "120",
                }, {
                    value1: "实际收款",
                    value2: "80",
                },
            ],
            valueMap: [
                { name: "概览名称", key: "value1" },
                { name: "概览数值", key: "value2" },
                { name: "单位", key: "value3" },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            scopelist: [],
            isvideo: true,
            totalNum: 0,
            chartlist: []
        };
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
        defaultdata(n) {
            this.getChartdata()
        },
    },
    beforeDestroy() {
    },
    methods: {
        ...methods,
        getChartdata() {
            let vdata = this.defaultdata.slice(2)
            this.totalNum = 0
            vdata.forEach(item => {
                this.totalNum += +item.value2
            })
            this.chartlist = vdata
            this.DrawEcharts()
        },
        DrawEcharts() {
            clearInterval(this.timer)
            this.timer = null
            var echarts = require('echarts')
            var TmyChart = echarts.init(this.$refs.piechart)
            var colorList = ['#0481FF', '#04FFFF'];
            var Toption = {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    show: false
                },
                grid: {
                },
                series: [
                    // 主要展示层的
                    {
                        radius: ['55%', '62%'],
                        center: ['50%', '50%'],
                        type: 'pie',
                        avoidLabelOverlap: false,
                        padAngle: 4,
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    return colorList[params.dataIndex]
                                }
                            },
                            borderRadius: 0,
                            borderColor: '#070e19', // 空隙的颜色，这里设置为白色
                            borderWidth: 2
                        },
                        label: {
                            show: false,
                        },
                        emphasis: {
                            scale: false,
                        },
                        labelLine: {
                            show: false
                        },
                        data: this.chartlist.map(item => {
                            return {
                                name: item.value1,
                                value: item.value2
                            }
                        })
                    },
                ]

            };
            Toption && TmyChart.setOption(Toption);
            this.timer = setInterval(function () {
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000)
        }
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        this.getChartdata()
    },
};
</script>

<style scoped lang="scss">
.lb {
    width: 905px;
    height: 350px;
    padding: 10px 0;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;

    .lb-left {
        margin-left: 18px;

        .left-item {
            width: 357px;
            height: 117px;
            background: url(@/assets/temimg9/left-item-bg.png) no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;

            &+.left-item {
                margin-top: 22px;
            }
        }

        .item-icon {
            margin-left: 34px;
            width: 75px;
            height: 87px;
        }
    }

    .item-text {
        margin: 10px 0 0 42px;

        .left-text1 {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 19px;
            color: #FFFFFF;
        }

        .left-text2 {
            font-family: Benmo Ziyu;
            font-weight: 400;
            font-size: 39px;
            color: #C6E6FF;
            margin-top: 10px;
            display: flex;
            align-items: flex-end;
            em {
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 19px;
                color: #5C90BA;
                margin: 0 0 6px 8px;
            }
        }
        .left-val {
            transition: all 2s ease-out;
        }
    }

    .center-line {
        margin: 0 36px;
        width: 2px;
        height: 230px;
        background: linear-gradient(to bottom, #102442, #647E99, #102442);
    }

    .pie-chart {
        width: 420px;
        height: 230px;
        position: relative;
    }
    .pie-content {
        width: 100%;
        height: 100%;
    }

    .bt1 {
        width: 212px;
        height: 212px;
        position: absolute;
        top: calc(50% - 106px);
        left: calc(50% - 106px);
        animation: rotateXZ 3s linear infinite;
    }

    .bt2 {
        width: 60px;
        height: 48px;
        position: absolute;
        top: 50%;
        left: 52%;
        transform: translate(-50%, -50%);
    }

    @keyframes rotateXZ {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(360deg);
        }
    }

    .rotateXZ-element {
        animation: rotateXZ 4s linear infinite;
    }

    .pie-item {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);

        .pie-line {
            width: 74px;
            height: 4px;
        }

        .line-text1 {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            line-height: 16px;
            margin-top: 20px;
        }

        .line-text2 {
            font-family: none;
            font-weight: 600;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 20px;
            margin-top: 32px;
        }

        .line-internal {
            height: 4px;
        }

        &.pie-item-0 {
            left: 0;

            .pie-line {
                background: #083572;
            }

            .line-internal {
                background: #0481FF;
            }

            .line-text1 {
                color: #0481FF;
            }
        }

        &.pie-item-1 {
            right: 0;

            .pie-line {
                background: #046C72;
            }

            .line-internal {
                background: #04FFFF;
            }

            .line-text1 {
                color: #06FFFF;
            }
        }
    }
    .unit {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #d1e2ea;
        position: absolute;
        left: 0px;
        top: -30px;
    }
}
</style>